<template>
  <div class="header-container">
    <!-- Logo 部分 -->
    <div class="logo">
      <div class="wrapper">
        <img
            class="logo-main"
            :style="logoStyle"
            src="@/assets/logo.png"
            alt="Logo"
        />
        <img
            src="@/assets/logo_bj.png"
            alt="Logo Background"
            class="logo-background"
        />
      </div>
    </div>

    <!-- 导航菜单部分 -->
    <el-header class="app-header">
      <div class="header-content">
        <el-menu
            class="horizontal-nav"
            mode="horizontal"
            :ellipsis="false"
            background-color="#b92000"
            text-color="#fff"
            active-text-color="#ffd04b"
            :default-active="activeIndex"
            @select="handleSelect"
        >
          <el-menu-item
              v-for="item in navItems"
              :key="item.index"
              @click="routerUrl(item.path)"
              :style="menuItemStyle"
              :index="item.index"
          >
            {{ item.title }}
          </el-menu-item>
        </el-menu>
      </div>
    </el-header>
  </div>
</template>

<script>
export default {
  name: 'HeaderContainer',
  props: {
    // 当前激活的菜单项
    activeIndex: {
      type: String,
      default: '1'
    }
  },
  data() {
    return {
      // 导航菜单配置
      navItems: [
        { index: '1', title: '首页', path: '/' },
        { index: '2', title: '彩種介紹', path: '/czIntroduce' },
        { index: '3', title: '開獎公告', path: '/lotteryRecordList' },
        { index: '4', title: '新聞公告', path: '/newsNotice' },
        { index: '5', title: '企業介紹', path: '/companyProfile' }
      ],
      // Logo 样式
      logoStyle: {
        position: 'absolute',
        marginTop: '15px',
        marginLeft: '10px'
      },
      // 菜单项样式
      menuItemStyle: {
        fontSize: '16px',
        width: '5rem',
        fontWeight: 'bold !important'
      }
    }
  },
  methods: {
    /**
     * 路由跳转
     * @param {String} path - 路由路径
     */
    routerUrl(path) {
      if(path==='/lotteryRecordList' && this.checkDevice()){
        path='/mobileRecordList'
      }
      this.$router.push(path)
    },
    checkDevice() {
      debugger
      this.screenWidth = window.innerWidth
      return  this.screenWidth < 768
    },
    /**
     * 菜单选择事件
     * @param {String} index - 菜单项的index
     * @param {String} indexPath - 菜单项的indexPath
     */
    handleSelect(index, indexPath) {
      this.$emit('menu-select', index, indexPath)
    }
  }
}
</script>

<style scoped>
.header-container {
  width: 1170px;
  //margin-bottom: 10px;
}

.logo {
  position: relative;
}

.logo .wrapper {
  position: relative;
}

.logo-main {
  z-index: 2;
}

.logo-background {
  width: 100%;
  z-index: 1;
}

.app-header {
  padding: 0;
  background-color: #b92000;
}

.header-content {
  width: 100%;
}

.horizontal-nav {
  display: flex;
  justify-content: center;
  border-bottom: none;
}
.carousel-image {
  width: 100%;
  height: 100%;
  object-fit: fill !important;
}
/* 响应式设计 */
@media (max-width: 768px) {
  .logo-main {
    width: 80px;
  }

  .horizontal-nav {
    flex-wrap: wrap;
  }

  .el-menu-item {
    width: 4rem !important;
    font-size: 14px !important;
  }
  .header-container {
    width: 100%;
    //margin-bottom: 10px;
  }
  .carousel-image {
    width: 100%;
    height: 100%;
    object-fit: fill !important;
  }
}
</style>